import {Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {PreorderType} from '../../../smoothr-web-app-core/enums/PreorderType';
import moment, {Moment} from 'moment';
import {TranslateService} from '@ngx-translate/core';
import {RepositoryService} from '../../../smoothr-web-app-core/services/repository/repository.service';
import {AlertController, ModalController} from '@ionic/angular';
import {MatSnackBar} from '@angular/material/snack-bar';
import RepositoryInterface from '../../../smoothr-web-app-core/directives/repository-directive';
import {OrderListAction} from '../../enums/OrderListAction';
import {AppComponent} from '../../app.component';
import {ModalInfoComponent} from '../modal-info/modal-info.component';
import {OrderUtils} from '../../../smoothr-web-app-core/utils/order-utils';
import Article from '../../../smoothr-web-app-core/models/Article';
import ArticleOption from '../../../smoothr-web-app-core/models/ArticleOption';
import Order from '../../../smoothr-web-app-core/models/Order';
import {PromoCodeType} from '../../../smoothr-web-app-core/models/PromoCodeType';
import {
    defaultsToArticleOption,
    getBasePrice,
    maxFskOfOrder,
    numberD,
    numberToCurrency,
    sleep,
} from '../../../smoothr-web-app-core/utils/utils';
import {AnalyticsService} from '../../../smoothr-web-app-core/services/analytics/analytics.service';
import {NoteArticleModalComponent} from '../note-article-modal/note-article-modal.component';
import {NavigationService} from 'src/app/services/navigation.service';
import ArticleGroup from 'src/smoothr-web-app-core/models/ArticleGroup';
import {OrderType} from 'src/smoothr-web-app-core/enums/OrderType';
import {Api} from 'src/smoothr-web-app-core/api/api';
import {Company} from 'src/smoothr-web-app-core/models/CompanyCode';
import {AddPromocodeModalComponent} from '../add-promocode-modal/add-promocode-modal.component';
import {DeliveryDetailsModalComponent} from '../delivery-details-modal/delivery-details-modal.component';
import {SignInModalComponent} from '../sign-in-modal/sign-in-modal.component';
import {SignUpModalComponent} from '../sign-up-modal/sign-up-modal.component';
import PromoCode from 'src/smoothr-web-app-core/models/PromoCode';
import {AddGiftCardDialogComponent} from '../loyalty-components/add-gift-card-dialog/add-gift-card-dialog.component';
import {
    BeforeCreateOrderSelectTimeDialogComponent
} from '../before-create-order-select-time-dialog/before-create-order-select-time-dialog.component';
import {Location} from '@angular/common';
import {ValidationUtils} from "../../../smoothr-web-app-core/utils/validation-utils";
import {CheckoutModalComponent} from "../checkout-modal/checkout-modal.component";
import ArticleCategory from "../../../smoothr-web-app-core/models/ArticleCategory";

@Component({
    selector: 'app-order-content',
    templateUrl: './order-content.component.html',
    styleUrls: ['order-content.component.scss'],
})
export class OrderContentComponent extends RepositoryInterface implements OnInit {
    @ViewChild('swiperSlider') swiper: ElementRef | null;

    @Output() openCheckout = new EventEmitter<void>();
    @Output() closeOrderContent = new EventEmitter();

    moment = moment;
    public openUserInfo: boolean = false;
    isValid = false;
    loading = false;
    isLargeScreen = AppComponent.largeScreen;
    ou = OrderUtils;
    pt = PreorderType;
    differenceToMvo: number;
    @Input()
    fromMenu = false;
    isOpeningTimeSheet = false;


    promoError: string;
    tip = 0;
    totalPriceValue = '';
    totlaPriceBeforeDiscount = '';
    fullTotalPrice = 0;
    slots: Moment[] = [];
    showAgeVefiried: boolean = false;
    ageVerified: boolean = false;
    recommendationArticles: Article[] = [];
    numberToCurrency = numberToCurrency;
    numberD = numberD;
    companyDisount = '';
    storeDiscount = '';
    public piggyPoints = 0;
    public minFoodSpotSubsidy: number = 0;
    calculateTaxesLoading = false;
    public loadingSlots = false;

    constructor(
        public translate: TranslateService,
        protected repository: RepositoryService,
        public modalCtrl: ModalController,
        private snackbarCtrl: MatSnackBar,
        private alertCtrl: AlertController,
        private analytics: AnalyticsService,
        private navigationService: NavigationService,
        public location: Location
    ) {
        super(repository);
        this.validate();
    }

    get hasArticles(): boolean {
        return !!this.order && this.order.orderedArticles.length > 0;
    }

    ngOnInit() {
        super.ngOnInit();
        this.analytics.openOrderContent();
    }

    async startAutoPlaySlider() {
        try {
            await sleep(1500);
            this.swiper.nativeElement?.swiper?.update;
            this.swiper.nativeElement?.swiper?.autoplay?.start();
            // console.log(this.swiper.nativeElement.swiper.update())
        } catch (e) {
            console.log(e, 'Problem with playing swiper...');
        }
    }

    onVenue() {
        super.onVenue();
        this.validate();

        const map = new Map();


        if (this.order.orderedArticles.length) {
            // const recommendations = [];
            const orderedArticles = new Map(this.order.orderedArticles.map(a => [a.article._id, a.article]))


            this.order.orderedArticles.forEach(article => {
                [...article.article.mainRecommendationsFromCategory, ...article.article.mainRecommendations].forEach(rec => {
                    if (orderedArticles.has(rec)) return;

                    this.venue?.articleCategories.forEach(c => {
                        c.articles.forEach(a => {
                            if (rec === a._id && !map.has(a._id)) {
                                a.categoryId = c._id
                                map.set(a._id, a);
                            }
                        })
                    })
                })
            })

            this.recommendationArticles = [...map.values()];
            const category = this.venue.articleCategories.find(c => (c.name.en.toLowerCase() + c.name.de.toLowerCase()).includes('drink'));
            if (this.order.orderedArticles.find(a => a.categoryId === category._id || a.article.categoryId === category._id)) {
                this.recommendationArticles = this.recommendationArticles.filter(a => a.categoryId !== category._id)
            }
        }
    }

    reloadPriceNew(articleValue: Article) {
        const articleGroup = new ArticleGroup();
        articleGroup.article = articleValue;
        articleGroup.groups = defaultsToArticleOption(articleValue, [], [], OrderType.PREORDER, this.order.preorder.type);
        articleGroup.quantity = 1;
        const article = JSON.parse(JSON.stringify(articleGroup.article)) as Article;
        let price = OrderUtils.totalPrice(articleGroup, this.order?.type, this.order.preorder.type);

        const processedGroups: string[] = [];

        article.groups.forEach(grp => {
            if (processedGroups.indexOf(grp._id) >= 0) return;
            if (ValidationUtils.isGroupDependencyFulfilled(articleGroup.article, articleGroup.groups, grp).times < 0) return;
            if (grp.requiredAmount == grp.limit) {
                const minimumItem = this.minOfItem(grp.articles, opt => numberD(opt.price));

                price += numberD(minimumItem.price) * grp.requiredAmount;
                processedGroups.push(grp._id);
            }
        });
        const tagPrice = this.findTagPrice(articleValue);
        let finalPrice = price - tagPrice;

        return numberToCurrency(finalPrice, this.order.currency);
    }

    findTagPrice(article: Article) {
        if (article && article.tags && article.tags.length > 0 && article.tags.find(it => it.identifier.includes('deposit'))) {
            const foundTag = article?.tags?.find(
                it =>
                    it?.identifier === 'deposit25' ||
                    it?.identifier === 'deposit15' ||
                    it?.identifier === 'deposit08' ||
                    it?.identifier === 'deposit28'
            );
            if (foundTag) {
                if (foundTag.identifier === 'deposit25') {
                    return 0.25;
                }
                if (foundTag.identifier === 'deposit15') {
                    return 0.15;
                }
                if (foundTag.identifier === 'deposit08') {
                    return 0.08;
                }
                if (foundTag.identifier === 'deposit28') {
                    return 0.28;
                }
                return 0;
            }
            return null;
        } else if (article?.deposit) {
            return numberD(article.deposit);
        } else {
            return null;
        }
    }

    private minOfItem<T>(items: T[], transformer: (item: T) => number): T {
        if (items.length === 1) {
            return items[0];
        }
        const values = items.map(item => transformer(item));
        const min = Math.min(...values);
        const index = values.indexOf(min);
        return items[index];
    }

    onCustomer(): void {
        super.onCustomer();
        if (this.order) {
            // this.totalPrice();
        }
    }

    onOrder() {
        super.onOrder();
        if (this.order && this.order.orderedArticles && this.order.orderedArticles.length > 0) {
            this.analytics.orderHasProducts();
        }
        this.validate();
        if (this.order) {
            this.totalPrice();
        }
    }

    async onAction(index: number, event: OrderListAction) {
        switch (event) {
            case OrderListAction.add:
                this.order.orderedArticles[index].quantity += 1;
                break;
            case OrderListAction.delete:
                if (OrderUtils.isBogoOrFreeArticlePromo(this.order) && this.order.promoCode.type === PromoCodeType.BOGO) {
                    const bogoArticleIndex = this.order.orderedArticles.findIndex(ag => ag.isPromo);
                    const bogoArticle = this.order.orderedArticles[bogoArticleIndex];
                    const matchingBogoArticleIndices = this.order.orderedArticles
                        .map((ag, agIndex) => {
                            return ag.article._id === bogoArticle.article._id &&
                            !ag.isPromo &&
                            OrderUtils.bogoPrice(ag, this.order.type, this.order.preorder.type) ===
                            OrderUtils.bogoPrice(bogoArticle, this.order.type, this.order.preorder.type)
                                ? agIndex
                                : -1;
                        })
                        .filter(agIndex => agIndex !== -1);
                    if (matchingBogoArticleIndices.find(bogoIndex => bogoIndex === index) !== undefined) {
                        // article that should be removed is a possible parent of promoCode article
                        if (matchingBogoArticleIndices.length === 1) {
                            // only that article is possible parent of promoCode. If this article is removed the PromoCode and PromoArticle
                            // should also be removed. Ask user.
                            const bogoAlert = await this.alertCtrl.create({
                                header: this.translate.instant('remove_bogo_alert.header'),
                                message: this.translate.instant('remove_bogo_alert.message'),
                                buttons: [
                                    {
                                        text: this.translate.instant('remove_bogo_alert.button_remove'),
                                        handler: () => {
                                            this.order.orderedArticles[bogoArticleIndex].isPromo = false;
                                            this.order.promoCode = null;
                                            this.order.orderedArticles.splice(index, 1);
                                            bogoAlert.dismiss();
                                        },
                                    },
                                    {
                                        text: this.translate.instant('remove_bogo_alert.button_keep'),
                                        handler: () => {
                                            bogoAlert.dismiss();
                                        },
                                    },
                                ],
                            });
                            await bogoAlert.present();
                            await bogoAlert.onDidDismiss();
                            break;
                        }
                    }
                }
                this.order.orderedArticles.splice(index, 1);
                break;
            case OrderListAction.note:
                this.noteArticle(index);
                break;
            case OrderListAction.edit:
                const modal = await this.modalCtrl.create({
                    cssClass: AppComponent.largeScreen ? 'item-modal large-modal' : 'item-modal',
                    component: ModalInfoComponent,
                    componentProps: {
                        // copy article group
                        articleGroup: JSON.parse(JSON.stringify(this.order.orderedArticles[index])),
                        recommend: false,
                    },
                    showBackdrop: true,
                    backdropDismiss: true,
                });
                await modal.present();
                const response = await modal.onDidDismiss();
                if (response.data && response.data.articleGroup) {
                    const promoAgIndex = this.order.orderedArticles.findIndex(oa => oa.isPromo);
                    if (
                        OrderUtils.isBogoOrFreeArticlePromo(this.order) &&
                        this.order.promoCode.type === PromoCodeType.BOGO &&
                        this.order.orderedArticles[index].article._id === this.order.orderedArticles[promoAgIndex].article._id &&
                        OrderUtils.bogoPrice(response.data.articleGroup, this.order.type, this.order.preorder.type) <
                        OrderUtils.bogoPrice(this.order.orderedArticles[promoAgIndex], this.order.type, this.order.preorder.type)
                    ) {
                        this.order.orderedArticles[promoAgIndex].isPromo = false;
                        const newPromoAg = JSON.parse(JSON.stringify(response.data.articleGroup));
                        newPromoAg.isPromo = true;
                        this.order.orderedArticles.push(newPromoAg);
                    }
                    this.order.orderedArticles[index] = response.data.articleGroup;
                    this.repository.onOrderChange(this.order);
                }
                break;
            case OrderListAction.remove:
                if (this.order.orderedArticles[index].quantity > 1) {
                    this.order.orderedArticles[index].quantity -= 1;
                } else {
                    await this.onAction(index, OrderListAction.delete);
                    return;
                }
                break;
        }
        this.repository.onOrderChange(this.order);
    }

    async signIn() {
        try {
            await this.modalCtrl.dismiss();
        } catch (e) {
        }
        const result = await SignInModalComponent.show(this.modalCtrl);
        if (result === 'sign-up') {
            this.signUp();
        }
    }

    async signUp() {
        try {
            await this.modalCtrl.dismiss();
        } catch (e) {
        }
        const result = await SignUpModalComponent.show(this.modalCtrl);
    }

    public async changeTime() {
        const result = await BeforeCreateOrderSelectTimeDialogComponent.show(
            this.modalCtrl,
            this.order,
            this.venue,
            this.order.preorder.type
        );

        if (result?.slot) {
            this.order.asap = false;
            this.order.orderAt = result.slot;
        }
        console.log('orderat', this.order.orderAt);
        this.repository.onOrderChange(this.order);
    }


    async submit() {
        this.validate();
        if (!this.isValid || this.loading) {
            return;
        }

        this.closeOrderContent.emit(true)
    }

    validate() {
        if (!this.order || !this.venue || !this.order.preorder) {
            this.isValid = false;
            return;
        }
        const result = OrderUtils.validateOrder(this.venue, this.order);

        let checkSubcidyForFoodSpot = true;
        this.differenceToMvo = result.movDifference;
        const orderFSK = maxFskOfOrder(this.order);

        if (orderFSK > 0) {
            this.showAgeVefiried = true;
            if (!this.ageVerified) {
                this.isValid = false;
                return;
            }
        } else {
            this.showAgeVefiried = false;
        }

        this.isValid = result.valid && checkSubcidyForFoodSpot;
    }

    checkAvailableOrder(order: Order) {
        try {
            let companyCode: Company | null = null;
            if (this.order?.preorder?.type === PreorderType.FOOD_SPOT) {
                companyCode = this.repository.companyCode$.getValue() ?? null;
                const totalPrice = OrderUtils.orderTotalPrice(this.order, true, true, companyCode);

                if (
                    (totalPrice === 0 || totalPrice) &&
                    companyCode &&
                    companyCode.subsidyOrderMinimum &&
                    Number(companyCode.subsidyOrderMinimum) > 0
                ) {
                    return {
                        value: totalPrice >= Number(companyCode.subsidyOrderMinimum),
                        min: Number(companyCode.subsidyOrderMinimum) - totalPrice,
                    };
                } else {
                    return {value: true, min: 0};
                }
            }
            return {value: true, min: 0};
        } catch (e) {
            return {value: true, min: 0};
        }
    }

    amountOfPoints() {
        return OrderUtils.orderTotalPrice(this.order, true, true) + this.tip;
    }

    mapGroup(articleGroup: ArticleGroup) {
        if (!this.venue || !this.order) {
            return articleGroup;
        }
        if (articleGroup.isHalfPizza) {
            const foundArticle = this.venue.articleCategories
                .map(it => {
                    if (it.visible) {
                        const foundArticle = it.articles.find(ar => ar._id === articleGroup.article._id);

                        return foundArticle ?? null;
                    } else {
                        return null;
                    }
                })
                .filter(it => !!it);
            if (foundArticle.length === 1) {
                const test = JSON.parse(JSON.stringify(articleGroup)) as ArticleGroup;
                test.article = JSON.parse(JSON.stringify(foundArticle[0]));
                return test;
            }
            return articleGroup;
        }
        return articleGroup;
    }

    private async calculateTaxes(order: Order) {
        if (order.orderedArticles.length <= 0) {
            return 0;
        }
        if (this.calculateTaxesLoading) {
            return 0;
        }
        this.calculateTaxesLoading = true;
        let result = 0;
        const copyOfOrder = JSON.parse(JSON.stringify(order)) as Order;
        try {
            copyOfOrder.userUid = this.customer?.uid ?? '';
            copyOfOrder.preorder.name = 'calculate taxes';
            copyOfOrder.preorder.email = 'dnd@smoothr.de';
            copyOfOrder.preorder.number = '+49234234324';
            const response = (await Api.calculateTaxes(copyOfOrder)).data;
            if (response?.totalPrice && response?.totalNetPrice) {
                result = Number(response.totalPrice) - Number(response.totalNetPrice);
            }
            this.calculateTaxesLoading = false;

            return Math.round(result * 100) / 100;
        } catch (e) {
            console.log('CATCH ERROR', e);
            this.calculateTaxesLoading = false;
            return result;
        }
    }

    async totalPrice() {
        let companyCode = null;
        if (this.order?.preorder?.type === PreorderType.FOOD_SPOT) {
            companyCode = this.repository.companyCode$.getValue() ?? null;
        }
        const resultOfTaxes = await this.calculateTaxes(this.order);
        this.order.tax = numberToCurrency(resultOfTaxes, this.order.currency);
        const totalPrice = OrderUtils.orderTotalPrice(this.order, true, true, companyCode, true);
        this.totalPriceValue = numberToCurrency(totalPrice, this.order.currency);
        const totalSumBeforeDiscount = OrderUtils.orderTotalPrice(this.order, false, false) + this.tip - resultOfTaxes;
        this.totlaPriceBeforeDiscount = numberToCurrency(totalSumBeforeDiscount >= 0 ? totalSumBeforeDiscount : 0, this.order.currency);
        this.fullTotalPrice = OrderUtils.orderTotalPrice(this.order, false, false);
        if (!this.storeDiscount && this.order.preorder.type === PreorderType.FOOD_SPOT) {
            const code = this.repository.companyCode$.getValue();
            if (code && code.storeDiscount) {
                this.storeDiscount = (Number(code.storeDiscount) * 100).toString() + '%';
            }
        }
        if (!this.companyDisount && this.order.preorder.type === PreorderType.FOOD_SPOT) {
            const code = this.repository.companyCode$.getValue();
            if (code?.subsidy) {
                this.companyDisount = numberToCurrency(Number(code.subsidy), this.order.currency);
            }
        }

        try {
            this.piggyPoints = Math.round(totalPrice * 10);
        } catch (e) {
            console.log(e);
        }
    }

    replace(index: number, article: Article, options: ArticleOption[]) {
        this.order.orderedArticles[index].quantity = 1;
        this.order.orderedArticles[index].article = article;
        this.order.orderedArticles[index].groups = options;
    }

    onPromoApplied(order: Order) {
        this.promoError = null;
        this.repository.onOrderChange(order);
    }

    onDeletePromo() {
        const order = OrderUtils.removePromo(this.order);
        this.repository.onOrderChange(order);
    }

    onPromoCodeError(error: string) {
        if (!error) {
            // error just resetting error no error happened
            return;
        }
        // Promo error
        this.snackbarCtrl.open(error, null, {duration: 2000});
        this.repository.onOrderChange(OrderUtils.removePromo(this.order));

        this.promoError = error;
    }

    async backToMenu() {
        if (AppComponent.largeScreen) {
            this.close();
        } else {
            await sleep(200);
            this.location.back();
        }
    }

    async noteArticle(index: number) {
        const modal = await this.modalCtrl.create({
            cssClass: 'short-info-modal auto-height',
            component: NoteArticleModalComponent,
            componentProps: {
                // copy article group
                articleGroup: JSON.parse(JSON.stringify(this.order.orderedArticles[index])),
                recommend: false,
            },
            showBackdrop: true,
            backdropDismiss: true,
        });
        await modal.present();
        const response = await modal.onDidDismiss();
        if (response?.data || response.data === '') {
            this.order.orderedArticles[index].note = response?.data;
        }
    }

    handleChangeRadio(event: { detail: { value: string } }) {
    }

    login() {
        this.navigationService.signIn();
    }

    checkPageIfHaveGrid(articleGroup: ArticleGroup) {
        return (
            articleGroup.article.groups.length > 0 &&
            articleGroup.article.groups.filter(it => !!it.tags.find(tag => tag.identifier === 'half_pizza')).length > 0
        );
    }

    identify(index, item) {
        return item?.group;
    }

    changeAgeVerification() {
        this.validate();
    }

    addArticle(article: Article) {
    }

    checkMeasurmentPlusPfand(article: Article) {
        let result = '';
        if (!this.order) {
            return;
        }
        const pfandValue = this.checkPfandTag(article);
        if (pfandValue) {
            result =
                this.translate.instant('pfand_text.zzgl') +
                (pfandValue === 'deposit15' ? numberToCurrency(0.15, this.order.currency) : numberToCurrency(0.25, this.order.currency)) +
                this.translate.instant('pfand_text.pfand') +
                '<br/>';
        } else {
            if (result.length > 0) {
                result = result + ')';
            }
        }
        if (article?.measurement && article?.measurement?.unit && article?.measurement?.amount) {
            result =
                result +
                ' ' +
                article.measurement?.refAmount +
                ' ' +
                article.measurement?.refUnit +
                ' = ' +
                this.numberToCurrency(getBasePrice(article, OrderType.PREORDER, this.order.preorder.type), this.order.currency);
        }
        return result;
    }

    checkPfandTag(article: Article) {
        if (article.tags?.length === 0) {
            return '';
        }
        const deposit25 = article.tags.find(it => it.identifier === 'deposit25') ? 'deposit25' : '';
        const deposit15 = article.tags.find(it => it.identifier === 'deposit15') ? 'deposit15' : '';

        return deposit15 || deposit25;
    }

    close() {
        if (AppComponent.largeScreen) {
            this.closeOrderContent.emit();
        } else {
            this.navigationService.menu();
        }
    }

    async openModal(item: Article) {
        if (this.loading) {
            return;
        }

        const articleGroup = new ArticleGroup();
        articleGroup.article = item;
        articleGroup.groups.push(...defaultsToArticleOption(item, [], item.defaults, this.order?.type, this.order.preorder.type));
        articleGroup.quantity = 1;

        const modal = await this.modalCtrl.create({
            cssClass: AppComponent.largeScreen ? 'item-modal large-modal' : 'item-modal',
            component: ModalInfoComponent,
            componentProps: {
                articleGroup,
            },
            mode: 'ios',
            backdropDismiss: true,
        });
        await modal.present();
        const response = await modal.onDidDismiss();
        if (response.data && response.data.articleGroup) {
            OrderUtils.addToOrder(this.order, response.data.articleGroup, this.analytics);

            this.repository.onOrderChange(this.order);
        }
    }

    async navToPromo() {
        await this.modalCtrl.dismiss();
        this.navigationService.promo();
    }

    public formatTime(order: Order) {
        if (order.orderAt) {
            return moment(order.orderAt).format('HH:mm');
        } else {
            return 'Asap';
        }
    }

    public formatYear(order: Order) {
        if (order.orderAt) {
            return moment(order.orderAt).locale(this.translate.currentLang.toLocaleLowerCase()).format('dddd Do MMMM');
        } else {
            return moment().locale(this.translate.currentLang.toLocaleLowerCase()).format('dddd Do MMMM');
        }
    }

    async openAddToBasketPromoCode() {
        const result = await AddPromocodeModalComponent.show(this.modalCtrl, this.order, this.venue);
        if (result?.order) {
            this.repository.onOrderChange(result.order);
        }
    }

    async loadGiftCard() {
        try {
            const result = await AddGiftCardDialogComponent.show(this.modalCtrl, this.venue, this.order);
            if (result?.giftCard) {
                this.order.giftCard = result?.giftCard;
                this.repository.onOrderChange(this.order);
            } else {
                if (result?.order) {
                    this.repository.onOrderChange(result.order);
                }
            }
        } catch (e) {
        }
    }

    public changeTip(tipValue: number) {
        this.tip = tipValue;
        this.totalPrice();
    }

    async changeDetails() {
        const result = await DeliveryDetailsModalComponent.show(this.modalCtrl, this.order, this.venue, this.customer);
        if (result) {
            this.repository.onOrderChange(result);
        }
    }

    deleteCoupon(promocode: PromoCode) {
        if (this.order.promoCodes.length > 0) {
            this.order.promoCodes = this.order.promoCodes.filter(it => it?._id !== promocode._id);
            this.order.orderedArticles = this.order.orderedArticles.filter(
                articleGroup => !(promocode?.value?.includes(articleGroup.article._id) && articleGroup.isPromo)
            );
            this.repository.onOrderChange(this.order);
        }
    }

    onDeleteGiftCard() {
        this.order.giftCard = null;
        this.repository.onOrderChange(this.order);
    }

    trackByRec(index: number, article: Article): string {
        return article._id;
    }

    addRecommendedArticle(a: Article, i) {
        const articleGroup = new ArticleGroup();
        articleGroup.article = a;
        articleGroup.groups.push(
            ...defaultsToArticleOption(
                a,
                [],
                a.defaults,
                this.order?.type,
                this.order.preorder.type
            )
        );
        articleGroup.quantity = 1;
        OrderUtils.addToOrder(this.order, articleGroup, this.analytics)
        this.repository.onOrderChange(this.order);
        this.recommendationArticles.splice(i, 1)
    }

    protected readonly OrderUtils = OrderUtils;
    protected readonly PreorderType = PreorderType;
}
